export default {
    getOrder: state => state.order,
    getOrderSales: state => state.orderSales,
    getOrderPurchase: state => state.orderPurchase,
    getRecoil: state => state.recoil,
    getById:state=>{
      return state.orderID;
      },
  }
  